import React, { useState, useEffect } from "react";
import "./styles.less";
import { useTranslation } from "react-i18next";
import { getDefaultLang, langs } from "../../utils";
// import { MobileFooter } from "./MobileFooter";
import Tooltip from "rc-tooltip";
import { MobileFooter } from "../Footer/MobileFooter";
const defaultLang = getDefaultLang();

const setCookieLang = (lang) => {
  const topLevelDomain = window.location.hostname
    .split(".")
    .slice(-2)
    .join(".");
  document.cookie = `_authing_lang=${lang}; path=/; domain=${topLevelDomain}`;
};

export const Footer = () => {
  let { i18n, t } = useTranslation();

  const [lang] = useState(defaultLang);
  //
  const change = (event) => {
    const _lang = event.target.value;
    i18n.changeLanguage(_lang);
    setCookieLang(_lang);
    window.location.reload();
  };
  const onOutLink = (path) => {
    window.location.href = path;
  };

  useEffect(() => {
    i18n.changeLanguage(lang);
    setCookieLang(lang);
  }, [lang, i18n]);

  const userManegeList = [
    {
      title: `${t("common.common.product-verify")}`,
      path: "/verify",
      log: "footer/mobilexpress",
    },
    {
      title: `${t("common.common.product-comp")}`,
      path: "/learn/guard",
      log: "footer/universalogin",
    },
    {
      title: `${t("common.common.product-sso")}`,
      path: "/learn/sso",
      log: "footer/sso",
    },
    {
      title: `${t("common.common.product-mfa")}`,
      path: "/mfa",
      log: "footer/mfa",
    },
    {
      title: t("common.common.product-gateway"),
      path: "/gateway-integration",
      log: "footer/gateway",
    },
  ];

  const solutionList = [
    {
      title: t("common.footer.footer-solution-wechat"),
      path: "/solutions/wechat",
      log: "footer/wechateco",
    },
    {
      title: t("common.nav.nav-solution-build-idaas"),
      path: "/solutions/build-idaas",
      log: "footer/newidaas",
    },
    {
      title: t("common.nav.nav-solution-idaas"),
      path: "/solutions/idaas",
      log: "footer/newiam",
    },
    {
      title: t("common.nav.nav-solution-okta"),
      path: "/solutions/okta",
      log: "footer/vsokta",
    },

    {
      title: t("common.footer.footer-solution-cognito"),
      path: "/solutions/cognito",
      log: "footer/vsaws",
    },
  ];

  const developList = [
    {
      title: `${t("common.footer.footer-support-doc")}`,
      path: "//docs.authing.cn/",
      log: "footer/doc",
    },
    {
      title: `${t("common.footer.footer-support-community")}`,
      path: "//forum.authing.cn/",
      log: "footer/forum",
    },
    {
      title: `${t("common.footer.footer-support-Github")}`,
      path: "//github.com/authing",
      log: "footer/github",
    },
    {
      title: `${t("common.footer.footer-support-blog")}`,
      path: "//blog.authing.cn/blog/",
      log: "footer/techblog",
    },
    // {
    //   title: `Authing Timeline`,
    //   path: "/changelog",
    // },
    // {
    //   title: t("common.footer.footer-pay-news"),
    //   path: "/pay-news",
    // },
  ];
  const communityLink = [
    {
      imgUrl: "//files.authing.co/authing-website/github.svg",
      icon: "icon authing-icon authing-wechat-pc",
      path: "//github.com/Authing",
      type: "wechat",
      bg: "#2FDF6E",
    },
    {
      imgUrl: "//files.authing.co/authing-website/github.svg",
      icon: "icon authing-icon authing-github-line",
      path: "//github.com/Authing",
      bg: "#000",
      log: "footer/githubicon",
    },

    {
      imgUrl: "//files.authing.co/authing-website/zhihu.svg",
      icon: "icon authing-icon authing-zhihu-fill",
      path: "//www.zhihu.com/org/authing",
      bg: "#0066FF",
      log: "footer/zhihuicon",
    },
    {
      imgUrl: "//files.authing.co/authing-website/gitter.svg",
      icon: "icon authing-icon authing-question-answer-fill",
      path: "//forum.authing.cn/",
      bg: "#FFCB1B",
      log: "footer/forumicon",
    },
  ];
  const companyAddress = [
    {
      city: t("common.footer.beijing"),
      address: t("common.footer.beijing-company-address"),
      addressUrl:
        "https://map.baidu.com/search/%E5%8C%97%E8%BE%B0%E4%B8%96%E7%BA%AA%E4%B8%AD%E5%BF%83-b%E5%BA%A7/@12957096.065,4838990.38,19z?querytype=s&da_src=shareurl&wd=%E5%8C%97%E8%BE%B0%E4%B8%96%E7%BA%AA%E4%B8%AD%E5%BF%83-b%E5%BA%A7&c=131&src=0&pn=0&sug=0&l=12&b=(12913638.56,4802627.47;13004838.56,4848067.47)&from=webmap&biz_forward=%7B%22scaler%22:2,%22styles%22:%22pl%22%7D&device_ratio=2",
    },
    {
      city: t("common.footer.shanghai"),
      address: t("common.footer.shanghai-company-address"),
      addressUrl:
        "https://map.baidu.com/search/%E4%B8%8A%E6%B5%B7%E5%B8%82%E6%9D%A8%E6%B5%A6%E5%8C%BA%E6%94%BF%E6%B0%91%E8%B7%AF%20300/@13526698.060111606,3650411.68,17.82z?querytype=s&da_src=shareurl&wd=%E4%B8%8A%E6%B5%B7%E5%B8%82%E6%9D%A8%E6%B5%A6%E5%8C%BA%E6%94%BF%E6%B0%91%E8%B7%AF%20300&c=289&src=0&pn=0&sug=0&l=19&b=(13526042.625,3650077;13526739.625,3650393)&from=webmap&biz_forward=%7B%22scaler%22:2,%22styles%22:%22pl%22%7D&device_ratio=2",
    },
    {
      city: t("common.footer.shenzhen"),
      address: t("common.footer.shenzhen-company-address"),
      addressUrl:
        "https://map.baidu.com/poi/讯美科技广场-3号楼/@12685261.782909092,2561348.135,19z?uid=7662e9e5fd09cdb3841541f4&ugc_type=3&ugc_ver=1&device_ratio=2&compat=1&pcevaname=pc4.1&querytype=detailConInfo&da_src=shareurl",
    },
    {
      city: t("common.footer.chengdu"),
      address: t("common.footer.chengdu-company-address"),
      addressUrl:
        "https://map.baidu.com/search/%E5%9B%9B%E5%B7%9D%E7%9C%81%E6%88%90%E9%83%BD%E5%B8%82%E9%AB%98%E6%96%B0%E5%8C%BA%E5%A4%A9%E5%BA%9C%E4%BA%94%E8%A1%97200%E5%8F%B7/@11584949.095,3551926.08,19z?querytype=s&da_src=shareurl&wd=%E5%9B%9B%E5%B7%9D%E7%9C%81%E6%88%90%E9%83%BD%E5%B8%82%E9%AB%98%E6%96%B0%E5%8C%BA%E5%A4%A9%E5%BA%9C%E4%BA%94%E8%A1%97200%E5%8F%B7&c=75&src=0&pn=0&sug=0&l=19&b=(11584592.845,3551748.58;11585305.345,3552103.58)&from=webmap&biz_forward=%7B%22scaler%22:2,%22styles%22:%22pl%22%7D&device_ratio=2",
    },
    {
      city: t("common.footer.wuhan"),
      address: t("common.footer.wuhan-company-address"),
      addressUrl:
        "https://map.baidu.com/search/%E6%AD%A6%E6%B1%89%E5%B8%82%E4%B8%9C%E6%B9%96%E6%96%B0%E6%8A%80%E6%9C%AF%E5%BC%80%E5%8F%91%E5%8C%BA%E5%85%B3%E5%B1%B1%E5%A4%A7%E9%81%93%E4%BF%9D%E5%88%A9%E5%9B%BD%E9%99%85%E4%B8%AD%E5%BF%83%207%20%E6%A5%BC%E6%B0%AA%E7%A9%BA%E9%97%B4/@12738102.301707588,3543590.205,14.78z?querytype=s&da_src=shareurl&wd=%E6%AD%A6%E6%B1%89%E5%B8%82%E4%B8%9C%E6%B9%96%E6%96%B0%E6%8A%80%E6%9C%AF%E5%BC%80%E5%8F%91%E5%8C%BA%E5%85%B3%E5%B1%B1%E5%A4%A7%E9%81%93%E4%BF%9D%E5%88%A9%E5%9B%BD%E9%99%85%E4%B8%AD%E5%BF%83%207%20%E6%A5%BC%E6%B0%AA%E7%A9%BA%E9%97%B4&c=289&src=0&pn=0&sug=0&l=17&b=(13525909.749999998,3650054.2825892856;13527486.370223215,3650769.0774107147)&from=webmap&biz_forward=%7B%22scaler%22:2,%22styles%22:%22pl%22%7D&device_ratio=2",
    },
  ];
  const menuList = [
    { name: t("common.footer.footer-product"), children: userManegeList },
    { name: t("common.footer.footer-solution"), children: solutionList },
    { name: t("common.footer.footer-support"), children: developList },
    {
      name: t("common.footer.footer-company"),
      children: [
        {
          title: t("common.footer.footer-company-phone"),
          path: null,
        },
        {
          title: t("common.footer.footer-company-email"),
          path: null,
        },
        {
          title: t("common.footer.mobile-total-company-address"),
          path: null,
        },
        {
          title: t("common.footer.mobile-shanghai-company-address"),
          path: null,
        },
        {
          title: t("common.footer.mobile-shenzhen-company-address"),
          path: null,
        },
        {
          title: t("common.footer.mobile-branch-company-address"),
          path: null,
        },

        {
          title: t("common.footer.mobile-wuhan-company-address"),
          path: null,
        },
      ],
    },
  ];

  const renderFooter = () => {
    return (
      <div className="authing-pc-footer-display">
        <div className="footer-warp">
          {/* <div className="inner"> */}
          <div className="footer-warp-bg">
            <div className="footer basic-column">
              {/* <div className="inner"> */}
              <div className="block-head">
                <div
                  className="footer-logo"
                  onClick={() => {
                    onOutLink("/");
                  }}
                >
                  <img
                    src={
                      "//files.authing.co/authing-website/authing-logo-0830.png"
                    }
                    alt=""
                  />
                </div>
                <div className="icons-link">
                  {communityLink.map((item, index) => {
                    if (item.type) {
                      return (
                        <div
                          className="wechat-code"
                          key={`${item.type}-${index}`}
                        >
                          <div
                            key={index}
                            className="icon-link"
                            style={{ backgroundColor: item.bg }}
                          >
                            <i className={item.icon}></i>
                          </div>
                          <div className="wechat-img">
                            <img
                              src="//files.authing.co/authing-website/wechat-code.jpg"
                              alt="authing"
                            />
                          </div>
                        </div>
                      );
                    } else {
                      return (
                        <a
                          key={`${item.type}-${index}`}
                          className="icon-link"
                          style={{ backgroundColor: item.bg }}
                          href={item.path}
                          target="_blank"
                          rel="noopener noreferrer"
                          data-log={item.log}
                        >
                          <i className={item.icon}></i>
                        </a>
                      );
                    }
                  })}
                </div>
                <div className="title-city">
                  {t("common.footer.city-title")}
                </div>
                <div className="city-warp">
                  {companyAddress.map((item, index) => (
                    <Tooltip
                      placement="bottom"
                      mouseLeaveDelay={0.001}
                      trigger={["hover"]}
                      overlay={item.address}
                      key={index + "tooltip"}
                    >
                      <a
                        className="title-item"
                        target="_blank"
                        rel="noopener noreferrer"
                        href={item.addressUrl}
                      >
                        {item.city}
                      </a>
                    </Tooltip>
                  ))}
                </div>
              </div>
              <div className="block">
                <div className="title">{t("common.footer.footer-product")}</div>
                {userManegeList.map((item, index) => {
                  return (
                    <a key={index} className="item" href={item.path}>
                      {item.title}
                    </a>
                  );
                })}
              </div>
              <div className="block">
                <div className="title">
                  {t("common.footer.footer-solution")}
                </div>
                {solutionList.map((item, index) => {
                  return (
                    <a
                      key={index}
                      className="item"
                      href={item.path}
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      {item.title}
                    </a>
                  );
                })}
              </div>
              <div className="block">
                <div className="title">{t("common.footer.footer-support")}</div>
                {developList.map((item, index) => {
                  return (
                    <a
                      key={index}
                      className="item"
                      href={item.path}
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      {item.title}
                    </a>
                  );
                })}
                <a
                  style={{ opacity: 0 }}
                  className="item"
                  href="https://authing.cn/sitemap.xml"
                >
                  {t("common.footer.footer-sitemap")}
                </a>
              </div>
              <div className="block last-block">
                <div className="title">{t("common.footer.footer-company")}</div>
                <a href="/joinus" className="item" data-log="footer/careers">
                  {t("common.footer.footer-company-joinus")}
                </a>
                <a
                  href="/tool-package"
                  className="item"
                  data-log="footer/mediakit"
                >
                  {t("common.tool-package.title")}
                </a>
                <div className="item-default">400 888 2106</div>
                <div className="item-default">
                  {t("common.footer.footer-company-email")}
                </div>
              </div>
            </div>
          </div>
          <div className="footer-bottom basic-column">
            <div className="friendly-link">
              {t("common.footer.footer-friendly-link")}:
              <a
                target="_blank"
                rel="noopener noreferrer"
                href="https://www.showmebug.com"
                data-log="footlink/showmebug"
              >
                ShowMeBug
              </a>
              <a
                target="_blank"
                rel="noopener noreferrer"
                href="https://www.eolink.com/"
                data-log="footlink/eolink"
              >
                Eolink
              </a>
              <a
                target="_blank"
                rel="noopener noreferrer"
                href="https://www.openeuler.org/zh/"
                data-log="footlink/openeuler"
              >
                openEuler
              </a>
              <a
                target="_blank"
                rel="noopener noreferrer"
                href="https://www.apifox.cn"
                data-log="footlink/apifox"
              >
                Apifox
              </a>
              <a
                target="_blank"
                rel="noopener noreferrer"
                href={t("common.footer.footer-apiseven-link")}
                data-log="footlink/api7ai"
              >
                api7.ai
              </a>
              <a
                target="_blank"
                rel="noopener noreferrer"
                href="https://www.teamcode.com/"
                data-log="footlink/teamcode"
              >
                TeamCode
              </a>
              <a
                target="_blank"
                rel="noopener noreferrer"
                href="https://www.juzibot.com"
                data-log="footlink/juzibot"
              >
                {t("common.footer.footer-juzi")}
              </a>
              <a
                target="_blank"
                rel="noopener noreferrer"
                href="https://www.mingdao.com?s=utm_62&utm_source=authing&utm_medium=referral&utm_campaign=friendLink&utm_content=website_footer"
              >
                {t("common.footer.footer-mingdao")}
              </a>
              <a
                target="_blank"
                rel="noopener noreferrer"
                href="https://www.apipost.cn/"
                data-log="footlink/apipost"
              >
                ApiPost
              </a>
              <a
                target="_blank"
                rel="noopener noreferrer"
                href="https://www.hengshi.com"
                data-log="footlink/hengshi"
              >
                {t("common.footer.footer-hengshi")}
              </a>
              <a
                target="_blank"
                rel="noopener noreferrer"
                href="https://www.datapipeline.com"
                data-log="footlink/datapipeline"
              >
                DataPipeline
              </a>
              <a
                target="_blank"
                rel="noopener noreferrer"
                href="https://www.mingque.com"
              >
                {t("common.footer.footer-mingque")}
              </a>
              <a
                target="_blank"
                rel="noopener noreferrer"
                href={t("common.footer.footer-gitlab-link")}
                data-log="footlink/gitlab"
              >
                {t("common.footer.footer-gitlab")}
              </a>
              <a
                target="_blank"
                rel="noopener noreferrer"
                href="https://tapdata.net"
                data-log="footlink/tapdata"
              >
                Tapdata
              </a>
              <a
                target="_blank"
                rel="noopener noreferrer"
                href="https://www.finclip.com"
                data-log="footlink/finclip"
              >
                FinClip
              </a>
              <a
                target="_blank"
                rel="noopener noreferrer"
                href="https://www.merico.cn/"
                data-log="footlink/merico"
              >
                {t("common.footer.footer-merico")}
              </a>
              <a
                target="_blank"
                rel="noopener noreferrer"
                href="https://fbmms.cn/"
              >
                {t("common.footer.footer-fbmms")}
              </a>
              <a
                target="_blank"
                rel="noopener noreferrer"
                href="https://www.dragontesting.cn/index.html"
              >
                {t("common.footer.footer-dragontest")}
              </a>
            </div>
            <div className="beian-language-box">
              <div className="beian-warp">
                <div className="gov-link">
                  <a
                    target="_blank"
                    rel="noopener noreferrer"
                    href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=11010802035968"
                  >
                    <img
                      src="//files.authing.co/authing-website/icon-beian-gov.png"
                      alt="beian"
                    />
                    <span>{t("common.footer.footer-beian")}</span>
                  </a>
                </div>
                <div className="gov-link">
                  <a
                    target="_blank"
                    rel="noopener noreferrer"
                    href="https://beian.miit.gov.cn/"
                  >
                    <span>{t("common.footer.footer-adress")}</span>
                  </a>
                </div>
                <div className="gov-link">
                  <span>{t("common.footer.footer-copyright")}</span>
                </div>
                <div className="gov-link">
                  <a
                    href="/privacy-policy.html"
                    className="item"
                    target="_blank"
                  >
                    <span>{t("common.footer.footer-privacy-policy")}</span>
                  </a>
                </div>
                <div className="gov-link">
                  <a
                    href="/service-agreement.html"
                    className="item"
                    target="_blank"
                  >
                    <span>{t("common.footer.footer-service-agreement")}</span>
                  </a>
                </div>
              </div>
              <div className="switch-lang" data-log="footer/language">
                <select name="lang" onChange={change} value={lang}>
                  {langs.map((item, index) => (
                    <option key={index} value={item.value}>
                      {item.label}
                    </option>
                  ))}
                </select>
                <i
                  className="icon authing-icon authing-expand_more_black_24dp icon-style"
                  style={{ color: "#aaa" }}
                ></i>
              </div>
            </div>
          </div>
          {/* </div> */}
        </div>
      </div>
    );
  };
  return (
    <>
      <MobileFooter menuList={menuList} communityLink={communityLink} />
      {renderFooter()}
    </>
  );
};
